import SettingsPage from '@/modules/settings/settings-page';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_dashboard/dashboard/settings/')({
  component: RouteComponent
});

function RouteComponent() {
  return <SettingsPage />;
}
